"use client";

import { useEffect, useState } from "react";
import axios from "axios";
// import NavbarDashboard from "../UserDashboardModule/NavbarDashboard";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import HeaderMain from "../dasboard-component/Components/HeaderMain";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";

export const Selection = () => {
  const [sportsOptions, setSportsOptions] = useState([]);
  const [selectedSport, setSelectedSport] = useState(null);
  const [arenaBookings, setArenaBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [invitedUsers, setInvitedUsers] = useState([]);

  const navigate = useNavigate();
  const { user } = useAuth();
  const token = user?.uid;

  // Date formatting function
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Define which sports are team sports
  const teamSports = ["Football", "Basketball", "Volleyball"];
  const isTeamSport = teamSports.includes(selectedSport);

  // Define which sports support doubles
  const doublesSupported = ["Table tennis", "Padel Tennis"];
  const supportsDoubles = doublesSupported.includes(selectedSport);

  // Styles
  const styles = {
    container: {
      maxWidth: "800px",
      margin: "20px auto",
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    sectionTitle: {
      fontSize: "clamp(18px, 4vw, 24px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
      textAlign: "center",
      position: "relative",
      paddingBottom: "10px",
    },
    titleUnderline: {
      content: "''",
      position: "absolute",
      bottom: "0",
      left: "50%",
      transform: "translateX(-50%)",
      width: "80px",
      height: "3px",
      backgroundColor: "#3498db",
      borderRadius: "2px",
    },
    selectWrapper: {
      marginBottom: "30px",
    },
    errorMessage: {
      color: "#e74c3c",
      fontWeight: "500",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#fdf2f2",
      borderRadius: "8px",
      marginTop: "10px",
      border: "1px solid #fed7d7",
      fontSize: "clamp(12px, 2.5vw, 14px)",
    },
    proceedButton: {
      marginTop: "20px",
      padding: "12px 30px",
      fontSize: "clamp(14px, 3vw, 16px)",
      backgroundColor: "#3498db",
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
      boxShadow: "0 4px 6px rgba(52, 152, 219, 0.3)",
      transition: "all 0.3s ease",
      width: "100%",
      maxWidth: "300px",
    },
    selectionStep: {
      backgroundColor: "#f8fafc",
      borderRadius: "12px",
      padding: "clamp(15px, 4vw, 25px)",
      marginBottom: "15px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      border: "1px solid #e2e8f0",
    },
    stepNumber: {
      display: "inline-block",
      width: "clamp(26px, 5vw, 30px)",
      height: "clamp(26px, 5vw, 30px)",
      backgroundColor: "#3498db",
      color: "white",
      borderRadius: "50%",
      textAlign: "center",
      lineHeight: "clamp(26px, 5vw, 30px)",
      marginRight: "10px",
      fontWeight: "bold",
      fontSize: "clamp(12px, 3vw, 16px)",
    },
    stepTitle: {
      display: "inline-block",
      fontSize: "clamp(16px, 3.5vw, 20px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "15px",
    },
    bookingDetails: {
      marginTop: "15px",
      padding: "clamp(12px, 3vw, 20px)",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    },
    bookingDetailsTitle: {
      fontSize: "clamp(15px, 3vw, 18px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "12px",
    },
    bookingInfo: {
      marginBottom: "12px",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    },
    invitedUsersSection: {
      marginTop: "15px",
    },
    invitedUsersTitle: {
      fontSize: "clamp(15px, 3vw, 18px)",
      fontWeight: "600",
      color: "#2c3e50",
      marginBottom: "10px",
    },
    invitedUsersList: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
    },
    invitedUserItem: {
      marginRight: "0",
      marginBottom: "0",
      fontSize: "clamp(12px, 2.5vw, 14px)",
    },
    userName: {
      fontWeight: "600",
      marginRight: "6px",
    },
    userStatus: {
      padding: "3px 6px",
      borderRadius: "4px",
      fontSize: "clamp(11px, 2vw, 13px)",
    },
    statusAccepted: {
      backgroundColor: "#dff0d8",
      color: "#468847",
    },
    statusRejected: {
      backgroundColor: "#f2dede",
      color: "#b94a48",
    },
    statusPending: {
      backgroundColor: "#fff2cc",
      color: "#a68a00",
    },
    statusMissed: {
      backgroundColor: "#f2f2f2",
      color: "#999999",
    },
  };

  // Fetch sports options
  useEffect(() => {
    const fetchSportsOptions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/common/get-sports`,
          { withCredentials: true }
        );

        // Filter out "General" sport and format options
        const formattedOptions = response.data
          .filter((sport) => sport.value !== "General")
          .map((sport) => ({
            value: sport.value,
            label: sport.value,
          }));

        setSportsOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching sports options:", error);
      }
    };

    fetchSportsOptions();
  }, []);

  // Fetch arena bookings when a sport is selected
  useEffect(() => {
    if (!selectedSport || !token) return;

    const fetchArenaBookings = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/arena-bookings?userId=${token}&sport=${selectedSport}`,
          { withCredentials: true }
        );
        setArenaBookings(response.data);
      } catch (error) {
        console.error("Error fetching arena bookings:", error);
      }
    };

    fetchArenaBookings();
  }, [selectedSport, token]);

  // Fetch invited users when a booking is selected
  useEffect(() => {
    if (!selectedBooking || selectedBooking === "0") {
      setInvitedUsers([]);
      return;
    }

    const fetchInvitedUsers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/user-add-game/api/selection/booking-invitations?bookingId=${selectedBooking}`,
          { withCredentials: true }
        );
        setInvitedUsers(response.data);
      } catch (error) {
        console.error("Error fetching invited users:", error);
      }
    };

    fetchInvitedUsers();
  }, [selectedBooking]);

  const handleProceed = () => {
    let data;

    const selectedBookingData = arenaBookings.find(
      (a) => a.booking_id === selectedBooking
    );

    if (isTeamSport) {
      // For team sports, just pass basic info - team names will be set per match
      data = {
        sport: selectedSport,
        arenaBooking: {
          id: selectedBooking,
          name: selectedBookingData?.Arena_name || "Guest Arena",
          date: formatDate(selectedBookingData?.date),
          time: selectedBookingData?.time,
        },
        invitedUsers: invitedUsers,
      };
    } else {
      // For individual sports, just pass basic info - players will be selected in game page
      data = {
        sport: selectedSport,
        arenaBooking: {
          id: selectedBooking,
          name: selectedBookingData?.Arena_name || "Guest Arena",
          date: formatDate(selectedBookingData?.date),
          time: selectedBookingData?.time,
        },
        invitedUsers: invitedUsers,
      };
    }

    if (selectedSport === "Snooker") {
      navigate("/add-snooker", { state: data });
    } else if (selectedSport === "Tennis") {
      navigate("/add-tennis", { state: data });
    } else if (selectedSport === "Table Tennis") {
      navigate("/add-table-tennis", { state: data });
    } else if (selectedSport === "Golf") {
      navigate("/add-golf", { state: data });
    } else if (selectedSport === "Football") {
      navigate("/add-football", { state: data });
    } else if (selectedSport === "Basketball") {
      navigate("/add-basketball", { state: data });
    } else if (selectedSport === "Padel Tennis") {
      navigate("/add-padel-tennis", { state: data });
    } else if (selectedSport === "Volleyball") {
      navigate("/add-volleyball", { state: data });
    } else if (selectedSport === "Cricket") {
      navigate("/add-cricket", { state: data });
    } else if (selectedSport === "Hockey") {
      navigate("/add-hockey", { state: data });
    } else if (selectedSport === "Swimming") {
      navigate("/add-swimming", { state: data });
    } else if (selectedSport === "Squash") {
      navigate("/add-squash", { state: data });
    } else {
      toast.error("This sport is not supported yet!");
    }
  };

  // Custom styles for react-select
  const selectStyles = {
    container: (base) => ({
      ...base,
      width: "100%",
      maxWidth: "100%",
      margin: "10px auto",
    }),
    control: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
      border: "1px solid #cbd5e0",
      padding: "4px",
      fontSize: "clamp(13px, 2.5vw, 15px)",
      "&:hover": {
        borderColor: "#3498db",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#3498db"
        : state.isFocused
        ? "#ebf5ff"
        : "white",
      color: state.isSelected ? "white" : "#4a5568",
      padding: "10px 15px",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#a0aec0",
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "clamp(13px, 2.5vw, 15px)",
    }),
  };

  return (
    <div className="App">
      <HeaderMain pageType="SelectionOfAddGames" />

      <div
        style={{
          ...styles.container,
          margin: window.innerWidth <= 768 ? "15px" : "20px auto",
          padding:
            window.innerWidth <= 480
              ? "15px"
              : window.innerWidth <= 768
              ? "18px"
              : "20px",
        }}
      >
        <h1 style={styles.sectionTitle}>
          Game Setup
          <div style={styles.titleUnderline}></div>
        </h1>

        <div style={styles.selectionStep}>
          <div>
            <span style={styles.stepNumber}>1</span>
            <span style={styles.stepTitle}>Select Sport Type</span>
          </div>
          <div style={styles.selectWrapper}>
            <Select
              className="selec"
              options={sportsOptions}
              onChange={(selectedOption) =>
                setSelectedSport(selectedOption.value)
              }
              styles={selectStyles}
              placeholder="Choose a sport..."
              isSearchable
            />
          </div>
        </div>

        {selectedSport && (
          <div style={styles.selectionStep}>
            <div>
              <span style={styles.stepNumber}>2</span>
              <span style={styles.stepTitle}>Select Arena Booking</span>
            </div>
            <div style={styles.selectWrapper}>
              <Select
                className="selec"
                options={[
                  ...arenaBookings.map((booking) => ({
                    value: booking.booking_id,
                    label: `${booking.Arena_name} - ${formatDate(
                      booking.date
                    )} at ${booking.time}`,
                  })),
                  { value: "0", label: "Guest Arena" }, // Guest Arena option
                ]}
                onChange={(selectedOption) =>
                  setSelectedBooking(selectedOption.value)
                }
                styles={selectStyles}
                placeholder="Choose a booking..."
                isSearchable
              />
              {arenaBookings.length === 0 && (
                <p style={styles.errorMessage}>
                  No arena bookings found for {selectedSport}, but you can
                  proceed with Guest Arena.
                </p>
              )}
            </div>

            {/* Show booking details and invited users */}
            {selectedBooking && selectedBooking !== "0" && (
              <div style={styles.bookingDetails}>
                <h4 style={styles.bookingDetailsTitle}>Booking Details</h4>
                {(() => {
                  const booking = arenaBookings.find(
                    (b) => b.booking_id === selectedBooking
                  );
                  return booking ? (
                    <div style={styles.bookingInfo}>
                      <p>
                        <strong>Arena:</strong> {booking.Arena_name}
                      </p>
                      <p>
                        <strong>Date:</strong> {formatDate(booking.date)}
                      </p>
                      <p>
                        <strong>Time:</strong> {booking.time}
                      </p>
                      <p>
                        <strong>Sport:</strong> {booking.sport_name}
                      </p>
                      {booking.about_facility && (
                        <p>
                          <strong>Facility:</strong> {booking.about_facility}
                        </p>
                      )}
                    </div>
                  ) : null;
                })()}

                {/* Show invited users */}
                {invitedUsers.length > 0 && (
                  <div style={styles.invitedUsersSection}>
                    <h4 style={styles.invitedUsersTitle}>Invited Players</h4>
                    <div style={styles.invitedUsersList}>
                      {invitedUsers.map((user) => (
                        <div key={user.id} style={styles.invitedUserItem}>
                          <span style={styles.userName}>{user.full_name}</span>
                          <span
                            style={{
                              ...styles.userStatus,
                              ...(user.status === "accepted"
                                ? styles.statusAccepted
                                : user.status === "rejected"
                                ? styles.statusRejected
                                : user.status === "pending"
                                ? styles.statusPending
                                : styles.statusMissed),
                            }}
                          >
                            {user.status}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {selectedBooking && (
          <div style={{ textAlign: "center" }}>
            <button
              style={styles.proceedButton}
              onClick={handleProceed}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#2980b9";
                e.currentTarget.style.boxShadow =
                  "0 6px 8px rgba(52, 152, 219, 0.4)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#3498db";
                e.currentTarget.style.boxShadow =
                  "0 4px 6px rgba(52, 152, 219, 0.3)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Proceed to Game Setup
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
